import React, { FC, ReactElement } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import AccountIcon from 'dibs-icons/exports/AccountOutlined';
import MaskIcon from 'dibs-icons/exports/Mask';
import { trackEvent } from 'dibs-tracking';

import styles from './AccountNavTrigger-style.scss';

type AccountNavTriggerProps = {
    isMasquerading: boolean;
    isVerifiedTrade?: boolean | null;
    name: string | ReactElement;
};

const messages = defineMessages({
    label: { id: 'AccountNavTrigger.label', defaultMessage: 'Account' },
    tradeLabel: { id: 'AccountNavTrigger.tradeLabel', defaultMessage: 'Workspace' },
});

const AccountNavTrigger: FC<AccountNavTriggerProps> = ({
    isMasquerading,
    isVerifiedTrade,
    name,
}) => {
    const intl = useIntl();
    return (
        <div data-tn="user-menu-logged-in" className={styles.accountWrapper}>
            <a data-tn="user-menu-logged-in-name" className={styles.name}>
                {isMasquerading ? (
                    <span data-tn="user-menu-masq-icon" className={styles.maskIcon}>
                        <MaskIcon />
                    </span>
                ) : null}
                {isMasquerading ? <span>({name})</span> : name}
            </a>
            <a
                aria-label={intl.formatMessage(
                    isVerifiedTrade ? messages.tradeLabel : messages.label
                )}
                className={styles.accountIcon}
                href={isVerifiedTrade ? '/trade/workspace/' : '/my/account/'}
                onClick={() => {
                    trackEvent({
                        category: 'navigation',
                        action: 'header navigation click',
                        label: 'user-nav|user icon',
                    });
                }}
            >
                <AccountIcon />
            </a>
        </div>
    );
};

export default AccountNavTrigger;
